module.exports = __webpack_public_path__ + "static/media/Subscription pending icon.22e3cd1c.svg";